import { getPalette } from 'owa-theme';

/**
 * Gets the location icon color based on the location type
 * @param placeType the place type, Unknown, public, private and room
 */
export default function getLocationCardIconColor(placeType: string): string {
    const palette = getPalette();
    if (placeType == 'Unknown') {
        return palette.neutralSecondary;
    }
    return palette.white;
}
